import http from 'axios'
import { camelizeKeys, decamelize } from 'humps'
import {
  selectFilter,
  selectOrder,
  selectPage,
  selectSort,
  selectHideCompleted,
  selectVendor
} from '../reducers/transcriptionTranscriptRequests'

export const FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_REQUEST =
  'transcrition/FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_REQUEST'
export const FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED =
  'transcrition/FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED'
export const FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_FAILED =
  'transcrition/FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_FAILED'
export const RETRY_TRANSCRIPT_REQUEST_REQUEST =
  'transcription/RETRY_TRANSCRIPT_REQUEST_REQUEST'
export const RETRY_TRANSCRIPT_REQUEST_SUCCEEDED =
  'transcription/RETRY_TRANSCRIPT_REQUEST_SUCCEEDED'
export const RETRY_TRANSCRIPT_REQUEST_FAILED =
  'transcription/RETRY_TRANSCRIPT_REQUEST_FAILED'
export const CHANGE_FILTER = 'transcription/CHANGE_FILTER'
export const CHANGE_ORDER = 'transcription/CHANGE_ORDER'
export const CHANGE_PAGE = 'transcription/CHANGE_PAGE'
export const CHANGE_SORT = 'transcription/CHANGE_SORT'
export const CHANGE_HIDE_COMPLETED = 'transcription/CHANGE_HIDE_COMPLETED'
export const CHANGE_VENDOR = 'transcription/CHANGE_VENDOR'

const fetchRequest = () => ({
  type: FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_REQUEST
})

const fetchSucceeded = data => ({
  type: FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_SUCCEEDED,
  data
})

const fetchError = error => ({
  type: FETCH_TRANSCRIPTION_TRANSCRIPT_REQUESTS_FAILED,
  error
})

export const changePage = page => dispatch => {
  dispatch({ type: CHANGE_PAGE, page })

  return dispatch(fetchTranscriptRequests())
}

export const changeSort = (sort, order) => dispatch => {
  dispatch({ type: CHANGE_SORT, sort, order })

  return dispatch(fetchTranscriptRequests())
}

export const changeFilter = filter => dispatch => {
  dispatch({ type: CHANGE_FILTER, filter })

  return dispatch(fetchTranscriptRequests())
}

export const changeVendor = vendor => dispatch => {
  dispatch({ type: CHANGE_VENDOR, vendor })

  return dispatch(fetchTranscriptRequests())
}

export const changeHideCompleted = hideCompleted => dispatch => {
  dispatch({ type: CHANGE_HIDE_COMPLETED, hideCompleted })

  return dispatch(fetchTranscriptRequests())
}

export const fetchTranscriptRequests = () => (dispatch, getState) => {
  dispatch(fetchRequest())

  const state = getState().transcriptionTranscriptRequests
  const hideCompleted = selectHideCompleted(state)
  let sort = decamelize(selectSort(state))

  if (selectOrder(state) === 'desc') {
    sort = `-${sort}`
  }

  let params = {
    'page[number]': selectPage(state),
    'filter[name_or_video_url]': selectFilter(state),
    'filter[vendor_id]': selectVendor(state),
    sort
  }

  if (hideCompleted) {
    params = { ...params, 'filter[incomplete]': 'true' }
  }

  return http
    .get('/r/api/transcript_requests', {
      params,
      headers: {
        Accept: 'application/vnd.api+json',
        Authorization: `Bearer ${getState().transcriptionKey}`
      }
    })
    .then(
      ({ data }) => dispatch(fetchSucceeded(camelizeKeys(data))),
      error => dispatch(fetchError(error))
    )
}

export const retryRequest = transcriptRequest => ({
  type: RETRY_TRANSCRIPT_REQUEST_REQUEST,
  transcriptRequest
})

export const retrySucceeded = (id, data) => ({
  type: RETRY_TRANSCRIPT_REQUEST_SUCCEEDED,
  alert: {
    type: 'SUCCESS',
    message: `Transcript request ${id} requeued for transcription`
  },
  id,
  data
})

export const retryFailed = (id, error) => ({
  type: RETRY_TRANSCRIPT_REQUEST_FAILED,
  alert: {
    type: 'ERROR',
    message: `Could not retry transcript request ${id}.`
  },
  id,
  error
})

export const retryTranscriptRequest = transcriptRequest => (
  dispatch,
  getState
) => {
  const id = transcriptRequest.id

  dispatch(retryRequest(transcriptRequest))

  return http
    .patch(
      `/r/api/transcript_requests/${id}/retry`,
      {},
      {
        headers: {
          Accept: 'application/vnd.api+json',
          Authorization: `Bearer ${getState().transcriptionKey}`,
          'Content-Type': 'application/vnd.api+json'
        }
      }
    )
    .then(
      ({ data }) => dispatch(retrySucceeded(id, camelizeKeys(data))),
      error => dispatch(retryFailed(id, error))
    )
}



// WEBPACK FOOTER //
// ../src/actions/transcriptionTranscriptRequestActions.js